import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const getUserRoleMenu = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.UserRoles.GET_USER_ROLE_MENU
  );
};

export default getUserRoleMenu;
